/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Activity_DeclinedInputs */



/**
* | output |
* | --- |
* | "You cancelled this change" |
*
* @param {Assistant_Activity_DeclinedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_activity_declined = /** @type {((inputs?: Assistant_Activity_DeclinedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Activity_DeclinedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous avez annulé cette modification")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie haben diese Änderung storniert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Hai annullato questa modifica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вы отменили это изменение.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cancelaste este cambio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("您取消了此更改")
	if (locale === "ja") return /** @type {LocalizedString} */ ("この変更はキャンセルされました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आपने यह बदलाव रद्द कर दिया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Você cancelou essa alteração.")
	return /** @type {LocalizedString} */ ("You cancelled this change")
});